module.exports = __webpack_public_path__ + "img/photo4.fe76637f.png";